const SPACING_UNIT = 4;
const MEASUREMENT_UNIT = 'px';

export const getSpacingPx = (multiplier: number): number => multiplier * SPACING_UNIT;
export const getSpacing = (multiplier: number): string =>
  `${multiplier * SPACING_UNIT}${MEASUREMENT_UNIT}`;
